<template>
  <div class="news-container">
    <!-- 顶部标题区域 -->
    <div class="title-section">
      <h1 class="main-title">新闻速递</h1>
      <p class="subtitle">关注我们，获取最新动态</p>
    </div>

    <!-- 新闻内容区域 -->
    <div class="news-content">
      <div class="news-content-height">
        <!-- 左侧图片 -->
        <div class="news-image">
          <img v-lazy="require('../../assets/img/news_left.png')" alt="新闻图片" />
        </div>
        
        <!-- 右侧新闻列表 -->
        <div class="news-list">
          <div 
            v-for="(news, index) in newsList" 
            :key="index" 
            class="news-item"
            @click="handleNewsClick(news)"
          >
            <div class="news-info">
              <h3 class="news-title">{{ news.Title }}</h3>
              <p class="news-date">{{ formatDate(news.CreateTime) }}</p>
              <p class="news-description" v-if="news.Content">{{ news.Content }}</p>
            </div>
            <div class="more-button">
              <span>了解更多</span>
            </div>
          </div>
        </div>
      </div>
    </div>

    <Footer />
  </div>
</template>

<script>
import Footer from "./Footer.vue";

export default {
  name: "News",
  components: {
    Footer
  },
  props: {
    imgserver: {
      type: String,
      default: ""
    }
  },
  data() {
    return {
      newsList: []
    }
  },
  mounted() {
    this.loadNews();
  },
  methods: {
    handleNewsClick(news) {
      // 处理新闻点击事件，跳转到详情页（兼容新路由需要 categoryId + productId）
      const categoryId = 39 // 新闻栏目的分类ID（如有需要可改为动态）
      const productId = news && (news.Id || news.id)
      this.$router.push({
        name: 'news-detail',
        params: { categoryId: String(categoryId), productId: String(productId) }
      })
    },
    formatDate(dateString) {
      // 格式化日期显示
      if (!dateString) return '';
      const date = new Date(dateString);
      return date.toLocaleDateString('zh-CN', {
        year: 'numeric',
        month: '2-digit',
        day: '2-digit'
      });
    },
    async loadNews() {
      try {
        const res = await this.$http.get(`/api/menus/${encodeURIComponent(39)}/full-tree`)
        const payload = res && res.data ? res.data : null
        let dataArray = []
        if (payload && Array.isArray(payload)) {
          dataArray = payload
        } else if (payload && payload.success && Array.isArray(payload.data)) {
          dataArray = payload.data
        }
        if (!Array.isArray(dataArray) || dataArray.length === 0) return
        const first = dataArray[0]
        const firstChild = first && Array.isArray(first.children) ? first.children[0] : null
        const contents = firstChild && Array.isArray(firstChild.contents) ? firstChild.contents.slice(0, 3) : []
        this.newsList = contents.map(item => ({
          Id: item.id,
          Title: item.title,
          CreateTime: item.publishTime || item.createdAt,
          Content: item.subtitle || item.body || ''
        }))
      } catch (e) {
        // 忽略错误，保持空列表
        // 可根据需要添加兜底数据
      }
    }
  }
};
</script>

<style lang="scss" scoped>
.news-container {
  width: 100%;
  min-height: 100vh;
  padding: 9.25rem 0 0;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: space-around;
  box-sizing: border-box;
  gap: 2rem;
}

.title-section {
  text-align: center;
  height: 10rem;
  padding: 0 20px;
  
  .main-title {
    font-size: 2.5rem; // 48px -> 2.5rem
    font-weight: 600;
    color: #000;
    margin-bottom: 1.5625rem; // 25px -> 1.5625rem
    position: relative;
    padding-bottom: 1.25rem; // 20px -> 1.25rem

    &::after {
      content: '';
      position: absolute;
      left: 50%;
      transform: translate(-50%);
      bottom: 0;
      width: 100px;
      height: 3px;
      background-color: #000;
    }
  }
  
  .subtitle {
    margin-top: 0.625rem; // 10px -> 0.625rem
    font-size: 1.25rem; // 20px -> 1.25rem
    color: #666;
    font-weight: 400;
    line-height: 1.5;
  }
}

.news-content {
  width: 80%;
  flex: 1;
  margin: 0 auto;
  padding: 0 20px;
  align-items: center;
  display: flex;

  .news-content-height {
    display: flex;
    width: 100%;
    max-height: 80%;
    align-items: center;
    gap: 3rem;
  }
  // justify-content: space-around;
}

.news-image {
  flex: 1;
  max-width: 50%;
  // text-align: right;
  
  img {
    max-width: 100%;
    border-radius: 8px;
    box-shadow: 0 4px 20px rgba(0, 0, 0, 0.1);
  }
}

.news-list {
  flex: 1;
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  gap: 1.5rem;

}

.news-item {
  display: flex;
  justify-content: space-between;
  align-items: flex-start;
  padding: 1.5rem;
  background: #fff;
  border-radius: 8px;
  box-shadow: 0 2px 10px rgba(0, 0, 0, 0.08);
  cursor: pointer;
  transition: all 0.3s ease;
  border-left: 4px solid transparent;

  &:hover {
    transform: translateY(-2px);
    box-shadow: 0 4px 20px rgba(0, 0, 0, 0.15);
    border-left-color: #5e7c85;
  }
}

.news-info {
  flex: 1;
  margin-right: 1rem;
}

.news-title {
  font-size: 1.125rem; // 18px
  font-weight: 600;
  color: #333;
  margin-bottom: 0.5rem;
  line-height: 1.4;
  display: -webkit-box;
  -webkit-line-clamp: 1;
  line-clamp: 1;
  -webkit-box-orient: vertical;
  overflow: hidden;
}

.news-date {
  font-size: 0.875rem; // 14px
  color: #666;
  margin-bottom: 0.75rem;
}

.news-description {
  font-size: 0.875rem; // 14px
  color: #777;
  line-height: 1.5;
  display: -webkit-box;
  -webkit-line-clamp: 1;
  line-clamp: 1;
  -webkit-box-orient: vertical;
  overflow: hidden;
}

.more-button {
  padding: 0.25rem 1rem;
  border: 1px solid #5e7c85;
  border-radius: 20px;
  background: transparent;
  transition: all 0.3s ease;
  white-space: nowrap;
  
  &:hover {
    background: #5e7c85;
    
    span {
      color: #fff;
    }
  }
  
  span {
    color: #5e7c85;
    font-size: 0.875rem; // 14px
    font-weight: 500;
    transition: color 0.3s ease;
  }
}

// 响应式设计
@media (max-width: 768px) {
  .news-content {
    flex-direction: column;
    gap: 2rem;
  }
  
  .news-image {
    max-width: 100%;
  }
  
  .title-section {
    .main-title {
      font-size: 2.25rem; // 36px -> 2.25rem
    }
    
    .subtitle {
      font-size: 1.125rem; // 18px -> 1.125rem
    }
  }
  
  .news-item {
    flex-direction: column;
    gap: 1rem;
  }
  
  .news-info {
    margin-right: 0;
  }
  
  .more-button {
    align-self: flex-end;
  }
}

// 小屏幕设备优化
@media (max-width: 480px) {
  .title-section {
    .main-title {
      font-size: 1.875rem; // 30px
    }
    
    .subtitle {
      font-size: 1rem; // 16px
    }
  }
  
  .news-title {
    font-size: 1rem; // 16px
  }
  
  .news-item {
    padding: 1rem;
  }
}
</style>
